/* SunFit – hjem/alle produkter runtime (flerspråkig kopia av den norska startsidan).
   Texterna för erbjudandet läses från #sfh: data-bogo (radens titel i versaler), data-bogo-h, data-other-p.
   USA: bara erbjudanden för besökarens marknad räknas. Finland: läser SunFit Bundles-radernas titlar (.sfb__title).
   1. Offer badges: reads each product's live Kaching deal and shows the bar title (e.g. "KJØP 1 FÅ 1 GRATIS")
      only when that product really has a buy-X-get-Y-free bar. No prices are shown anywhere.
   2. The "Dagens tilbud" band lists the products that currently carry that offer; hidden when none do.
   3. Scroll reveal. */
(function () {
  var R = document.getElementById('sfh');
  if (!R || R.getAttribute('data-sfh-init')) return;
  R.setAttribute('data-sfh-init', '1');
  R.classList.add('sfh-js');

  /* ---------- reveal ---------- */
  var rv = R.querySelectorAll('.sfh-rv');
  function showAll() { for (var i = 0; i < rv.length; i++) rv[i].classList.add('in'); }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    showAll();
  } else {
    var fired = false;
    var io = new IntersectionObserver(function (es) {
      fired = true;
      for (var i = 0; i < es.length; i++) {
        if (es[i].isIntersecting) { es[i].target.classList.add('in'); io.unobserve(es[i].target); }
      }
    }, { rootMargin: '0px 0px -6% 0px' });
    for (var i = 0; i < rv.length; i++) io.observe(rv[i]);
    setTimeout(function () { if (!fired) showAll(); }, 2000);
  }

  /* ---------- ticker: the markup holds two copies; four keep wide screens filled ---------- */
  var tr = R.querySelector('.sfh-ticker-track');
  if (tr) tr.innerHTML += tr.innerHTML;

  /* ---------- second image on hover (desktop only, so phones never download it) ---------- */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 750px)').matches) {
    var meds = R.querySelectorAll('.sfh-card-media[data-img2]');
    for (var q = 0; q < meds.length; q++) {
      var first = meds[q].querySelector('.sfh-img1'), im2 = document.createElement('img');
      im2.className = 'sfh-img2'; im2.src = meds[q].getAttribute('data-img2'); im2.alt = '';
      im2.setAttribute('aria-hidden', 'true'); im2.loading = 'lazy'; im2.decoding = 'async';
      if (first) meds[q].insertBefore(im2, first.nextSibling);
    }
  }

  /* ---------- offers ---------- */
  var BOGO = (R.getAttribute('data-bogo') || 'KJØP 1 FÅ 1 GRATIS').toUpperCase(), BOGO_H = R.getAttribute('data-bogo-h') || 'Kjøp 1, få 1 gratis', OTHER_P = R.getAttribute('data-other-p') || 'Tilbudet gjelder produktene under. Rabatten trekkes automatisk når du velger tilbudet på produktsiden.';
  var MKT = null;
  try { var kc = document.getElementById('kaching-bundles-config'); if (kc) MKT = JSON.parse(kc.textContent).marketId; } catch (e) {}
  var KEY = 'sfh-deals-v2-' + (MKT || ''), TTL = 10 * 60 * 1000;
  function readCache() {
    try { var o = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (o && Date.now() - o.t < TTL) return o.m; } catch (e) {}
    return null;
  }
  function writeCache(m) { try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), m: m })); } catch (e) {} }

  function parseBlocks(html) {
    var out = [], re = /<script[^>]*kaching-bundles-deal-block-settings[^>]*>([\s\S]*?)<\/script>/g, m;
    while ((m = re.exec(html))) {
      var t = (m[1] || '').trim();
      if (!t) continue;
      try { out.push(JSON.parse(t)); } catch (e) {}
    }
    if (MKT) out = out.filter(function (b) { return !b.marketId || String(b.marketId) === String(MKT); });
    if (!out.length) {
      // SunFit Bundles (Finland): första radens titel, om den lovar en gratis vara
      var t2 = html.match(/class="sfb__title"[^>]*>([^<]+)</);
      if (t2 && /(^|\D)1\D+1(\D|$).*(GRATIS|ILMAISEKSI|FREE)/i.test(t2[1])) out.push({ dealBars: [{ buyQuantity: 1, getQuantity: 1, getDiscountType: 'percentage', getDiscountValue: 100, title: t2[1].trim() }] });
    }
    return out;
  }
  // The deal's first buy-X-get-Y bar decides. It only counts when the extra item really is 100 % off,
  // so an offer called "gratis" that still charges for the second item gets no badge.
  function freeBar(block) {
    var bars = (block && block.dealBars) || [];
    for (var i = 0; i < bars.length; i++) {
      var b = bars[i];
      if ((b.buyQuantity || 0) >= 1 && (b.getQuantity || 0) >= 1) {
        return (b.getDiscountType === 'percentage' && Number(b.getDiscountValue) >= 100 && b.title) ? b : null;
      }
    }
    return null;
  }
  // Every rendered block (A/B versions included) must carry the offer, otherwise no badge.
  function offerTitle(blocks) {
    if (!blocks || !blocks.length) return null;
    var title = null;
    for (var i = 0; i < blocks.length; i++) {
      var b = freeBar(blocks[i]);
      if (!b) return null;
      if (!title) title = String(b.title).replace(/\s+/g, ' ').trim();
    }
    return title || null;
  }
  // Reads the product page only until Kaching's deal blocks have arrived, then stops the download.
  function fetchBlocks(h) {
    var ctrl = window.AbortController ? new AbortController() : null;
    function stop(rd) {
      try { if (ctrl) ctrl.abort(); } catch (e) {}
      try { if (rd) rd.cancel().catch(function () {}); } catch (e) {}
    }
    return fetch('/products/' + encodeURIComponent(h), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) {
        if (!r.ok) return null;
        if (!r.body || !r.body.getReader || !window.TextDecoder) return r.text().then(parseBlocks);
        var rd = r.body.getReader(), dec = new TextDecoder(), buf = '';
        function pump() {
          return rd.read().then(function (x) {
            if (x.done) return parseBlocks(buf);
            buf += dec.decode(x.value, { stream: true });
            var i = buf.indexOf('kaching-bundles-deal-block-settings');
            if (i < 0) { var i2 = buf.indexOf('class="sfb__title"'); if (i2 > -1 && buf.indexOf('<', i2 + 20) > -1) { stop(rd); return parseBlocks(buf); } }
            if (i > -1) {
              var end = buf.indexOf('END app snippet', i);
              if (end > -1) { stop(rd); return parseBlocks(buf.slice(0, end)); }
            }
            if (buf.length > 2000000) { stop(rd); return parseBlocks(buf); }
            return pump();
          });
        }
        return pump();
      })
      .catch(function () { return null; });
  }

  var cards = R.querySelectorAll('[data-h]');
  var handles = [];
  for (var c = 0; c < cards.length; c++) {
    var hh = cards[c].getAttribute('data-h');
    if (handles.indexOf(hh) < 0) handles.push(hh);
  }

  function norm(t) { return String(t || '').toUpperCase().replace(/\s+/g, ' ').trim(); }

  function apply(map) {
    var groups = {}, order = [];
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i], h = card.getAttribute('data-h'), t = map[h];
      var badges = card.querySelectorAll('.sfh-badge');
      for (var j = 0; j < badges.length; j++) {
        if (t) { badges[j].textContent = t; badges[j].hidden = false; }
        else { badges[j].hidden = true; }
      }
      if (t) {
        var k = norm(t);
        if (!groups[k]) { groups[k] = { title: t, items: [] }; order.push(k); }
        groups[k].items.push(card);
      }
    }
    var best = null;
    for (var o = 0; o < order.length; o++) if (!best || groups[order[o]].items.length > best.items.length) best = groups[order[o]];
    var faq = document.getElementById('sfh-faq-bogo');
    var band = document.getElementById('sfh-tilbud');
    var is11 = !!best && norm(best.title) === norm(BOGO);
    if (faq) faq.style.display = is11 ? '' : 'none';
    if (!band) return;
    if (!best) { band.hidden = true; return; }
    var head = document.getElementById('sfh-offer-h');
    if (head) head.textContent = is11 ? BOGO_H : best.title;
    var art = document.getElementById('sfh-offer-art');
    if (art) art.style.display = is11 ? '' : 'none';
    var para = document.getElementById('sfh-offer-p');
    if (para && !is11) para.textContent = OTHER_P;
    var list = document.getElementById('sfh-offer-list');
    if (list) {
      list.innerHTML = '';
      for (var n = 0; n < best.items.length; n++) {
        var it = best.items[n], a = document.createElement('a');
        a.className = 'sfh-chip';
        a.href = '/products/' + it.getAttribute('data-h');
        var src = it.getAttribute('data-thumb');
        if (src) { var im = document.createElement('img'); im.src = src; im.alt = ''; im.width = 30; im.height = 30; im.loading = 'lazy'; a.appendChild(im); }
        a.appendChild(document.createTextNode(it.getAttribute('data-name') || ''));
        list.appendChild(a);
      }
    }
    band.hidden = false;
  }

  function run() {
    var cached = readCache();
    if (cached) { apply(cached); return; }
    Promise.all(handles.map(function (h) {
      return fetchBlocks(h).then(function (bl) { return { h: h, ok: bl !== null, t: bl ? offerTitle(bl) : null }; });
    })).then(function (res) {
      var m = {}, allOk = true;
      for (var i = 0; i < res.length; i++) { m[res[i].h] = res[i].t; if (!res[i].ok) allOk = false; }
      if (allOk) writeCache(m);
      apply(m);
    });
  }
  if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 1200 });
  else setTimeout(run, 300);
})();
